import { motion } from 'framer-motion';
import styled from 'styled-components';

import { LayoutPosition, styledLayout, styledReset } from '@pkg/primitives';

import {
    cardTransition,
    CardVariant,
    cardVariants,
    modalWrapperTransition,
    ModalWrapperVariant,
    modalWrapperVariants,
} from './Modal.motion';

export const OuterBackground = styled(motion.div).attrs({
    variants: modalWrapperVariants,
    initial: ModalWrapperVariant.Hidden,
    animate: ModalWrapperVariant.Show,
    exit: ModalWrapperVariant.Hidden,
    transition: modalWrapperTransition,
})`
    ${styledReset.borderBox};
    ${styledLayout.positionCover({ position: LayoutPosition.Fixed })};
    z-index: 2000;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${({ theme }) => theme.shades.black[55]};
    padding: 0;
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 10px 0;
    }
`;

export const CardWrapper = styled(motion.div).attrs({
    variants: cardVariants,
    initial: CardVariant.Hidden,
    animate: CardVariant.Show,
    exit: CardVariant.Hidden,
    transition: cardTransition,
})`
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    max-width: unset;
    max-height: unset;
    position: absolute;
    background-color: #090719;
    overflow: hidden;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 100%;
        height: 100%;
        max-width: 668px;
        max-height: 655px;
        margin: 30px 0;
        position: relative;
        box-shadow: 0 0 25px 5px rgba(2, 1, 5, 0.5);
        border-radius: 30px;
    }
`;

export const Content = styled.div`
    height: 100%;
    --yat_scrollbar-thumb-color: ${({ theme }) => theme.colors.purple};
    overflow-y: auto;
    overscroll-behavior-y: contain;

    ${styledLayout.scrollbar({
        thumbColor: 'var(--yat_scrollbar-thumb-color)',
        trackColor: 'transparent',
    })}
`;
